import React from "react";
import {
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ContactInfo from "./ContactInfo";
import PersonalDataNoticeXs from "./small-ui/PersonalDataNoticeXs";

const PersonalDataNotice = ({ id, isXs }) => {
  const { t } = useTranslation();

  if (isXs) return <PersonalDataNoticeXs id={id} />;

  // Helper function to render text with line breaks
  const renderWithLineBreaks = (text) => {
    return text.split("\n").map((line, i) => (
      <React.Fragment key={i}>
        {line}
        {i < text.split("\n").length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <Paper elevation={1} sx={{ p: 4, mb: 4 }} id={id}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <i className="fas fa-database fa-2x" style={{ color: "#0c4d96" }}></i>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ ml: 2 }}
        >
          {t("privacy-policy.personal-data-notice.title")}
        </Typography>
      </Box>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.personal-data-notice.company.title")}
      </Typography>
      <Typography paragraph>
        {renderWithLineBreaks(
          t("privacy-policy.personal-data-notice.company.name")
        )}
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.personal-data-notice.manager.title")}
      </Typography>
      <Typography paragraph>
        {renderWithLineBreaks(
          t("privacy-policy.personal-data-notice.manager.info")
        )}
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.personal-data-notice.purposes.title")}
      </Typography>
      <List>
        {t("privacy-policy.personal-data-notice.purposes.items", {
          returnObjects: true,
        }).map((item, index) => (
          <ListItem key={index}>
            <ListItemText primary={`(${index + 1})${item}`} />
          </ListItem>
        ))}
      </List>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.personal-data-notice.complaints.title")}
      </Typography>
      <Typography paragraph>
        {t("privacy-policy.personal-data-notice.complaints.text")}
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.personal-data-notice.disclosure.title")}
      </Typography>
      <Typography paragraph>
        {t("privacy-policy.personal-data-notice.disclosure.text")}
      </Typography>

      <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.personal-data-notice.disclosure.procedure.title")}
      </Typography>
      <Typography paragraph>
        {t("privacy-policy.personal-data-notice.disclosure.procedure.text")}
      </Typography>

      <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.personal-data-notice.disclosure.proxy.title")}
      </Typography>
      <Typography paragraph>
        {t("privacy-policy.personal-data-notice.disclosure.proxy.text")}
      </Typography>

      <Typography fontWeight="bold">
        {t("privacy-policy.personal-data-notice.disclosure.proxy.legal.title")}
      </Typography>
      <List>
        {t("privacy-policy.personal-data-notice.disclosure.proxy.legal.items", {
          returnObjects: true,
        }).map((item, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <i
                className="fas fa-chevron-right"
                style={{ color: "#0c4d96" }}
              ></i>
            </ListItemIcon>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>

      <Typography fontWeight="bold">
        {t(
          "privacy-policy.personal-data-notice.disclosure.proxy.delegated.title"
        )}
      </Typography>
      <List>
        {t(
          "privacy-policy.personal-data-notice.disclosure.proxy.delegated.items",
          { returnObjects: true }
        ).map((item, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <i
                className="fas fa-chevron-right"
                style={{ color: "#0c4d96" }}
              ></i>
            </ListItemIcon>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>

      <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1, mt: 2 }}>
        {t("privacy-policy.personal-data-notice.disclosure.fee.title")}
      </Typography>
      <Typography paragraph>
        {t("privacy-policy.personal-data-notice.disclosure.fee.text")}
      </Typography>

      <ContactInfo />
    </Paper>
  );
};

export default PersonalDataNotice;
